import { render, staticRenderFns } from "./DebitorContacts.vue?vue&type=template&id=050c4fc4&"
import script from "./DebitorContacts.vue?vue&type=script&lang=js&"
export * from "./DebitorContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports